export function initNumberCounterPlugin() {
    // Check rapido
    if (document.querySelector('.js-number-counter')) {
        // Import dinamico
        import('./number_counter.js')
            .then(module => module.default())
            .catch(err => console.error('Error loading Number Counter:', err));
    }
}
